import React from 'react'

import { Flag } from 'components/_base'

type CampaignCountriesProps = {
  countries: any
  limit?: number
}

const CampaignCountries = ({ countries, limit = Infinity }: CampaignCountriesProps) => {
  const limitCountries = countries.slice(0, limit).map((country: any) => <Flag country={country} key={country} />)

  const countriesNumber = countries.length

  return (
    <div className="campaigns__countries-cell">
      {limitCountries}
      {countriesNumber > limit && <span>&hellip;</span> /* eslint-disable-line */}
    </div>
  )
}

export default CampaignCountries
